import React, { useState }  from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import cx from 'classnames'
import StoreCard from './card';
import Button from 'common/components/elements/buttons/primary';
import CircleLoader from 'common/components/elements/loader/circle';
import EmptyState from 'common/components/modules/empty-states';
import CountState from 'admin/views/media-modules/count-state';
import { Link } from 'react-router-dom';
import Router from 'admin/routes/router';
import { generateUriSegment } from 'common/utils/mediaRouteHelper';
import ReorderingContent, { SortableItem } from 'admin/views/reorder-content';
import StoreFilters from './filters';
import ContentRepostModal from 'common/components/modules/content-repost-modal';
import QueryParams from 'admin/utils/QueryParams';
import { createPortal } from 'react-dom';
import { moreInfoProps } from 'common/utils/utils';


const Store = ({
   data,
   loadingNewData,
   isEmpty,
   onFilterChange,
   searchValue,
   filterType,
   isMobile,
   openDeleteConfirmModal,
   onMoreInfoStore,
   isFilterFetching,
   allowAddContent,
   onShare,
   countesState,
   screenWidth,
   emptyFilters,
   onClearAllFilters,
   categories,
   onClickStoreCard,
   pinning,
   isReorderMode,
   setReorderMode,
   onSortEnd,
   onClickPreview,
   activFilters,
   goTo,
   isDemoMode,
   updateStoreList,
   isInsideModal,
   selections,
   onSelectItem,
   endList,
}) =>  {

   const [isOpenModal, setIsOpenModal] = useState(false)
   const [draggableItem, setDraggableItem] = useState(null)
   const [repostModal, setRepostModal] = useState({ isOpen: false, id: null })

   const onClickOpenRepostModal = (isOpen, id = null, data = {}) => {
      if(isOpen) {
         QueryParams.addQueryParam('repost', '')
      } else {
         QueryParams.removeQueryParam('repost')
      }
      setRepostModal({ isOpen, id, ...data })
   }

   const filtersView = (
      <StoreFilters
         screenWidth={ screenWidth }
         onFilterChange={ onFilterChange }
         activFilters={ activFilters }
         emptyFilters={ emptyFilters }
         categories={ categories }
         isReorderMode={ isReorderMode }
         onClearAllFilters={ onClearAllFilters }
         isEmpty={ isEmpty }
         searchValue={ searchValue }
      />
   )

   return (
      <>
         <div
            className={ cx({
               'admin-store-content pb-15 relative z-10': true,
               'min-h-[101%]': !endList && !isInsideModal && !loadingNewData,
            }) }
         >
            <>
               <div className={ cx({
                  'store-header-content flex flex-col gap-4 w-full ms:pt-8 ms:px-6 px-4': true,
                  '!pt-0': isInsideModal,
               }) }>
                  {
                     !isInsideModal &&
                     <div className={ `flex flex-row justify-between flex-wrap-reverse gap-2 ${ screenWidth < 1120 ? '!flex-col-reverse ' : '' }` }>
                        {
                           allowAddContent &&
                           <div
                              className={
                                 cx({
                                    'flex gap-2 max-xl:flex-wrap flex-1 items-center': true,
                                    '!flex-col !items-start': screenWidth < 768 || (isReorderMode && screenWidth < 950),
                                 })
                              }
                           >
                              <Button
                                 text='Add new store item'
                                 classNames='h-11 whitespace-nowrap !w-[fit-content] px-5 py-2.5'
                                 textSize='base'
                                 backgroundColor='action'
                                 iconName='add'
                                 iconPosition='left'
                                 borderRadius='large'
                                 onClick={ () => goTo('STORE_ADD_NEW') }
                                 primaryColor
                                 textClassName='ml-2'
                                 textMarginX='0'
                                 disabled={ isReorderMode }
                              />
                              <Button
                                 text='Create a bundle'
                                 classNames=' h-11 border border-divider whitespace-nowrap px-5 py-2.5 !w-[fit-content] intercom-create-a-bundle'
                                 textColor='major'
                                 fontIconColor='secondary'
                                 fontIconSize='extraLarge'
                                 textSize='base'
                                 backgroundColor='panel'
                                 iconName='bundle'
                                 iconPosition='left'
                                 borderRadius='large'
                                 onClick={ () => goTo('STORE_CREATE_BUNDLE') }
                                 textClassName='ml-2'
                                 textMarginX='0'
                                 disabled={ isReorderMode }
                                 darkIconColor='secodary-dark'
                              />
                              <Button
                                 text={ isReorderMode ? 'Done' : 'Reorder' }
                                 onClick={ setReorderMode }
                                 iconName={ isReorderMode ? '' : 'drag' }
                                 iconPosition='left'
                                 borderRadius='large'
                                 backgroundColor={ isReorderMode ? '' : 'major-dark' }
                                 textColor='major'
                                 fontIconColor='secondary'
                                 textSize='base'
                                 classNames={ cx({
                                    'px-5 py-[10px] flex flex-row gap-2 border border-divider h-11 !w-[fit-content] whitespace-nowrap ': true,
                                    'hover:!bg-hover intercom-reorder-content': !isReorderMode,
                                 }) }
                                 textMarginX='0'
                                 primaryColor={ isReorderMode }
                              />
                              {
                                 isReorderMode &&
                                 <Button
                                    text='Preview on my site'
                                    onClick={ onClickPreview }
                                    iconName='go-to'
                                    iconPosition='left'
                                    borderRadius='large'
                                    backgroundColor='major-dark'
                                    textColor='major'
                                    fontIconColor='secondary'
                                    textSize='base'
                                    classNames='px-5 py-2.5 flex flex-row gap-2 border border-divider h-11 !w-[fit-content] hover:!bg-hover whitespace-nowrap'
                                    textMarginX='0'
                                 />
                              }
                              {
                                 countesState && (
                                    <CountState
                                       state={ countesState }
                                       type={ isReorderMode ? `published item${ data?.length > 1 ? 's' : '' } can be reordered` : 'item' }
                                       className='ml-4 whitespace-nowrap max-[1024px]:justify-start mt-2 md:mt-auto !my-0'
                                       hideTooltip={ isReorderMode }
                                    />
                                 )
                              }
                           </div>
                        }
                        <div
                           className={ cx({
                              [`store-header-buttons flex flex-row gap-2`]: true,
                           })
                           }
                        >
                           {/* <div className='inline-flex !w-[fit-content] !h-[fit-content]'>
                              <Button
                                 text='Give feedback'
                                 textSize='small'
                                 iconName='new-feedback'
                                 fontIconSize='large'
                                 iconPosition='left'
                                 backgroundColor='transparent'
                                 padding='none'
                                 classNames='h-full group pl-[14px] py-2 intercom-give-feedback whitespace-nowrap'
                                 textColor='success'
                                 fontIconColor='success'
                                 alignment='end'
                              />
                           </div> */}
                           <div className='inline-flex !w-[fit-content] !h-[fit-content]'>
                              <Button
                                 text='More info on the store'
                                 textSize='small'
                                 iconName='attention-outline'
                                 fontIconSize='base'
                                 iconPosition='left'
                                 backgroundColor='transparent'
                                 padding='none'
                                 classNames='h-full px-[14px] py-2 whitespace-nowrap'
                                 primaryColor
                                 { ...moreInfoProps() }
                                 onClick={ onMoreInfoStore }
                              />
                           </div>
                        </div>
                     </div>
                  }
                  {
                     // ['store', 'chat', 'related_content'].includes(contentType) &&
                     isInsideModal && screenWidth > 1024 && !!document.getElementById('stores-filter-content') ?
                        createPortal(filtersView, document.getElementById('stores-filter-content'))
                        : filtersView
                  }
               </div>
               <ReorderingContent
                  contentType='store'
                  onSortEnd={ onSortEnd }
                  setDraggableItem={ (value) => {
                     setDraggableItem(value)
                  } }
                  data={ data }
               >
                  {
                     !isFilterFetching && data && data.map((item, index) => {
                        let tooltiptext = ''
                        const isSoldOut = item.active && !item.is_future_publish_enabled && !!item?.track_quantity && item?.number_in_stock_left === 0
                        const isContentBundleItem = item?.product_type === 'content_bundle_item'

                        if(item.is_future_publish_enabled) {
                           tooltiptext = 'scheduled'
                        } else if(!item.is_future_publish_enabled && !item.active) {
                           tooltiptext = 'unpublished'
                        }

                        if(isReorderMode && (item?.is_pinned || (!item.is_future_publish_enabled && !item.active) || item.is_future_publish_enabled)) {
                           return null
                        }


                        return (
                           <SortableItem
                              key={ item.id }
                              className='relative'
                              index={ index }
                              id={ item.id }
                              isRotate={ draggableItem === index }
                              type='store'
                              isReorderMode={ isReorderMode }
                              disabled={ !item?.active }
                              disabledState={ isReorderMode && !item?.active }
                              tooltiptext={ tooltiptext }
                           >
                              <Link
                                 to={  Router.route(isContentBundleItem ? 'STORE_EDIT_BUNDLE' : 'STORE_DETAILS').getCompiledPath({ id: generateUriSegment(item.id, item.name), title: item.name }) }
                                 className={ cx({
                                    'w-full h-full': true,
                                    '!rotate-2': draggableItem === index,
                                    '': isInsideModal,
                                 }) }
                                 key={ item.id }
                                 onClick={ (e) => {
                                    e.stopPropagation()
                                    if(isOpenModal || isInsideModal) {
                                       e.preventDefault()
                                    }
                                    onClickStoreCard()
                                    Router.route(isContentBundleItem ? 'STORE_EDIT_BUNDLE' : 'STORE_DETAILS').setTitle(item.name)
                                 } }
                              >
                                 <StoreCard
                                    data={ item }
                                    isMobile={ isMobile }
                                    openDeleteConfirmModal={ openDeleteConfirmModal }
                                    onShare={ onShare }
                                    publishDate={ item.publish_date }
                                    showTooltip={ !(!item.is_future_publish_enabled && !item.active) }
                                    className={ draggableItem === index ? '!rotate-2 overflow-hidden bg-transparent' : '' }
                                    disabled={ isReorderMode && !item?.active }
                                    pinning={ pinning }
                                    setIsOpenModal={ setIsOpenModal }
                                    is_pinned={ item?.is_pinned }
                                    endsDate={ item?.ends_in }
                                    isSoldOut={ isSoldOut }
                                    isDemoMode={ isDemoMode }
                                    onClickOpenRepostModal={ () => onClickOpenRepostModal(true, item?.id, { notify_members_on_publish: item?.notify_members_on_publish, send_tweet_on_publish: item?.send_tweet_on_publish }) }
                                    isInsideModal={ isInsideModal }
                                    onSelectItem={ () => onSelectItem(item) }
                                    isChecked={ !!selections?.includes(item.id) }
                                    isReorderMode={ isReorderMode }
                                 />
                              </Link>
                           </SortableItem>
                        )
                     })
                  }
               </ReorderingContent>
               {
                  isFilterFetching && (
                     <div className='w-full h-full flex items-center justify-center py-1 is-FilterEmpty'>
                        <CircleLoader
                           color='blue'
                        />
                     </div>
                  )
               }
               {
                  loadingNewData && (
                     <div className='w-full h-12 flex items-center justify-center py-1'>
                        <CircleLoader
                           color='blue'
                        />
                     </div>
                  )
               }
               {
                  isEmpty && !isFilterFetching && (
                     <div
                        className='flex w-full is-FilterEmpty'>
                        <EmptyState
                           type={ filterType === 'filter' ? 'filter' : 'search' }
                           result={  searchValue }
                        />
                     </div>
                  )
               }
            </>
         </div>
         {
            !!repostModal?.isOpen &&
               <ContentRepostModal
                  onCloseModal={ onClickOpenRepostModal }
                  insideModalSlug='new_bundle_published'
                  resourceId={ repostModal?.id }
                  callbackFunction={ (date) => {
                     const item = data.find(it => it?.id === repostModal?.id)
                     if(item) {
                        updateStoreList({
                           ...item,
                           last_repost_date: date,
                        })
                     }
                  } }
                  initialData={ {
                     notify_members_on_publish: repostModal?.notify_members_on_publish,
                     send_tweet_on_publish: repostModal?.send_tweet_on_publish,
                  } }
                  isDemoMode={ isDemoMode }
               />
         }
      </>
   );
}

Store.propTypes = {
   loadingNewData: PropTypes.bool,
   isEmpty: PropTypes.bool,
   onFilterChange: PropTypes.func,
   searchValue: PropTypes.string,
   filterType: PropTypes.string,
   data: PropTypes.array,
   openDeleteConfirmModal: PropTypes.func,
   isMobile: PropTypes.bool,
   isFilterFetching: PropTypes.bool,
   onMoreInfoStore: PropTypes.func,
   allowAddContent: PropTypes.bool,
   onShare: PropTypes.func,
   countesState: PropTypes.object,
   screenWidth: PropTypes.number,
   emptyFilters: PropTypes.bool,
   onClearAllFilters: PropTypes.func,
   categories: PropTypes.array,
   onClickStoreCard: PropTypes.func,
   pinning: PropTypes.func,
   setReorderMode: PropTypes.func,
   isReorderMode: PropTypes.bool,
   onSortEnd: PropTypes.func,
   onClickPreview: PropTypes.func,
   activFilters: PropTypes.object,
   goTo: PropTypes.func,
   isDemoMode: PropTypes.bool,
   updateStoreList: PropTypes.func,
   isInsideModal: PropTypes.bool,
   selections: PropTypes.array,
   onSelectItem: PropTypes.func,
   endList: PropTypes.bool,
};

Store.defaultProps = {
   openMode: false,
   pinning: PropTypes.func,
   isInsideModal: false,
};

export default Store;
